const servicesNavSVG = `
<?xml version="1.0" encoding="utf-8"?>
<!-- Generator: Adobe Illustrator 16.0.0, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
<!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 1.1//EN" "http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd">
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
 width="23.4px" height="20.567px" viewBox="0 0 23.4 20.567" enable-background="new 0 0 23.4 20.567" xml:space="preserve">
<path fill="#F2E91E" d="M22.719,2.742c-0.001,0-0.003,0-0.004,0h-6.216V2.057C16.499,0.923,15.577,0,14.442,0H8.958
C7.824,0,6.901,0.923,6.901,2.057v0.686H0.686C0.304,2.742,0,3.056,0,3.428v15.083c0,1.133,0.922,2.057,2.057,2.057h19.287
c1.134,0,2.057-0.924,2.057-2.057V3.443c0-0.002,0-0.003,0-0.004C23.374,2.989,23.097,2.745,22.719,2.742z M8.272,2.057
c0-0.378,0.308-0.686,0.686-0.686h5.484c0.378,0,0.686,0.308,0.686,0.686v0.686H8.272V2.057z M21.763,4.113L19.635,10.5
c-0.094,0.281-0.355,0.47-0.65,0.47h-3.857v-0.686c0-0.38-0.307-0.686-0.686-0.686H8.958c-0.378,0-0.686,0.306-0.686,0.686v0.686
H4.416c-0.295,0-0.557-0.188-0.65-0.47L1.637,4.113H21.763z M13.756,10.97v1.37H9.643v-1.37H13.756z M22.029,18.511
c0,0.377-0.308,0.686-0.686,0.686H2.057c-0.378,0-0.686-0.309-0.686-0.686V7.652l1.094,3.281c0.279,0.841,1.064,1.406,1.951,1.406
h3.856v0.686c0,0.379,0.307,0.686,0.686,0.686h5.484c0.379,0,0.686-0.307,0.686-0.686V12.34h3.857c0.887,0,1.67-0.565,1.951-1.406
l1.094-3.281V18.511z"/>
</svg>
`;

export default servicesNavSVG;



// WEBPACK FOOTER //
// ./src/Components/inlineSVGs/servicesNavSVG.js